import React from "react";
import { createPortal } from "react-dom";

import Tooltip from "components/Tooltip";

const InsightsHeaderTooltips = () =>
    createPortal(
        <>
            <Tooltip id="drawingTip" />
            <Tooltip id="photoGalleryTip" />
            <Tooltip id="versionHistoryTip" />
            <Tooltip id="insightsTagTip" />
            <Tooltip id="reviewProgressTip" />
            <Tooltip id="saveTip" />
        </>,
        document.body
    );

export default InsightsHeaderTooltips;
